import React, { useEffect, useRef, useState } from "react";
import { deleteData, getData, patchData } from "../../Service/ApiMethod";
import { RECURITER_NOTIFICATIONSLOG } from "../../Service/service";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BlackScreen from "./BlackScreen";
import { lang } from "../../lang";

const Notification = (props) => { 
  const { t } = useTranslation();
  const [ln,setLn] = useState('en')
  const [notification, setNotification] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [index, setIndex] = useState();
  const [blackPopup, setBlackPopup] = useState(false)
  const navigate = useNavigate();
  const seekerData = useRef()
  const countChange = props?.countChange;

  const handleRedirect = (type) => {
    console.log(type,"chandd;lkkkkkkkk");
  
    // navigate("/message");
    if (type == "job") {
      navigate("/vaccancy");
    } else if (type == "jobs") {
      navigate("/recommended-profiles", {
        state: { title: "Recommended Candidates" },
      });
    } else if (type == "Timesheet") {
      navigate("/vaccancy");
    } else if (type === "HireRequest") {
      navigate("/vaccancy");
    } else if (type == "Message") {
      navigate("/message");
    
    } else if (type == "Candidates") {
      navigate("/recommended-profiles", {
        state: { title: "Recommended Candidates" },
      });
    }
    setShowPopup(false);
    props?.setPopups(0);
  };



  const [pageNo,setPageno] = useState(1)
  const totalPage = useRef(1)
  const newNoti = useRef([])
  // const getNotifications = () => {
  //   // loaderAction(true)

  //   console.log(pageNo.current, "okkkkkkkkkk")
  //   setLoaders(true);
  //   getData(Constant.end_Point.NOTIFICATION + "?pgNo=" + pageNo.current)
  //     .then(async res => {
  //       const response = res;
  //       console.log("okkks", response)
  //       if (response.data.page_num == 1) {
  //         setLoaders(false)
  //         setFlatlistData(response.data.notification_log);
  //         console.log(response.data, "sd");
  //         totalPage.current = response.data.total_pages
  //         setLoaders(false);
  //       } else if (pageNo.current <= totalPage.current) {

  //         // console.log("okno",myVacancyData);

  //         if (response.data.notification_log != []) {
  //           let valuu = flatlistData
  //           response.data.notification_log.map((it) => {
  //             valuu.push(it)
  //           })
  //           setFlatlistData(valuu)
  //         }


  //         // updateVa.current = valuu
  //         // console.log("okno1",valuu);
  //         setLoaders(false);
  //       } else {
  //         setLoaders(false);
  //         // alert("No Data More")
  //       }



  //       // if (response.status_code === 200) {
  //       //   // setLoader(false);
  //       //   setLoader(false)
  //       //   setFlatlistData(response.data.notification_log);
  //       //   console.log(response.data, "sd");
  //       //   // loaderAction(false)
  //       //   setLoader(false)
  //       // } else {
  //       //   console.log('Error', response.message);
  //       //   // loaderAction(false)
  //       //   setLoader(false)
  //       // }
  //     })
  //     .catch(error => {
  //       console.log(error);
  //       // loaderAction(false)
  //       setLoader(false)
  //     });
  // }











  const getNotification = () => {
    console.log(pageNo,"ccssssssssssssss")
    getData(RECURITER_NOTIFICATIONSLOG + "?pgNo=" + pageNo)
      .then((response) => response.json())
      .then((res) => {
        newNoti.current = res.data.notification_log
        setNotification(res.data.notification_log);
        totalPage.current = res.data.total_pages
       
       
        console.log("Notification Data", res);
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  };

  console.log("notification", notification);

  const hanldeOptions = () => {
    setShowPopup(!showPopup);
  };

  const handleDelete = (id) => {
    const obj = {
      notification_log_id: id,
    };
    deleteData(obj, RECURITER_NOTIFICATIONSLOG)
      .then((response) => response.json())
      .then((data) => {
        console.log("deleted data", data.data);
        getNotification();
      })
      .catch((err) => {
        console.log(err.message);
      });
    setShowPopup(false);
    props?.notificationCountnumber();
    props?.changeCount(!countChange);
  };

  const handleRead = (id) => {
    const obj = {
      notification_log_id: id,
    };
    patchData(obj, RECURITER_NOTIFICATIONSLOG)
      .then((response) => response.json())
      .then((data) => {
        console.log("read Status", data);
        getNotification();
        props?.changeCount(!countChange);
      })
      .catch((err) => {
        console.log(err.message);
      });
    setShowPopup(false);
  };

  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  useEffect(() => {
    getNotification();
  }, []);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props?.closeModalWrtOutsideClick();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <>
      <div
        className="blur-screen-full-area flex-center "
        style={{
          position: "fixed",
          top: "0",
          zIndex: "99999999999999",
          height: "100vh",
          overflow: "auto",
          background: "rgb(0, 0, 0, 0.5",
        }}
      >
        <div className="notification " ref={wrapperRef}>
          <div className="space-between mb-4 d-flex">
            <p className="text">{t("Notification")}</p>
            <button
              onClick={props?.crossClose}
              className="text btn-none view-all"
            >
              {lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Close"]:""}
            </button>
          </div>
          {notification?.length > 0 ? (
            newNoti.current?.map((item, i) => {
              const datee = item?.created_at;
              // console.log('datee',datee)
              const dateTimeAgo = moment(new Date(datee)).fromNow();
              console.log("dateTimeAgo", dateTimeAgo);
              return (
                <>
                  <div
                    key={i}
                    className="row candidates-notification"
                    style={{
                      background: `${item?.is_read ? "white" : "#c5d3e9"}`,
                      padding: item?.is_read ? 0 : 10
                    }}
                    onClick={()=>{
                      if(item.type == "job"){
                      console.log(item,"okkkkkkkkkkkkkkkkkkkkkkkkkkkkkk")
                      seekerData.current = item
                      setBlackPopup(true)
                    }
                    }}
                  >
                    {item?.sender_image ? (
                      <div
                        className="col-2 px-0 reative"
                        style={{ marginTop: "10px" }}
                      >
                        {" "}
                        <img
                          src={item?.sender_image}
                          className="msg-profile mr-0 "
                          alt=""
                        />{" "}
                      </div>
                    ) : (
                      <div className="col-2 px-0 reative">
                        {" "}
                        <img className="msgnotif-imgg" src="./images/msg-noti.png " alt="" />{" "}
                      </div>
                    )}

                    {/* <img
              src="./images/msg1.png"
              className="msg-profile mr-0 second-notification-profile"
              alt=""
            /> */}
                    {/* <img
              src="./images/msg1.png"
              className="msg-profile mr-0 third-notification-profile"
              alt=""
            /> */}

                    <div className="col-8 pb-2">
                      <p
                        className="text"
                        style={{ whiteSpace: "break-spaces" }}
                      >
                        {item?.body}
                      </p>
                      <button
                        className="text"
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "1px solid blue",
                          color: "black",
                          background: "rgb(197, 211, 233)",
                        }}
                        onClick={(e) => {
                          // e.stopPropagation();
                          handleRedirect(item?.type);
                          handleRead(item?.id);
                          props?.changeCount(!countChange);
                        }}
                      >
                        {item?.type === "job"
                          ? `${t("View Job")}`
                          : "" || item?.type === "HireRequest"
                            ? `${t("View Hire Request")}`
                            : "" || item?.type === "Message"
                              ? `${t("View Message")}`
                              : "" || item?.type === "Timesheet"
                                ? `${t("View Timesheet")}`
                                : "" || item?.type === "Candidates"
                                  ? `${t("View Candidates")}`
                                  : ""}
                      </button>

                      {/* <button className="view-notification">View Candidates</button> */}
                      {/* <span className="view-notification">{dateTimeAgo}</span> */}
                    </div>

                    <div
                      className="col-2 px-0"
                      style={{ position: "relative" }}
                    >
                      <span
                        className="text notification-time-status"
                        style={{
                        
                        }}
                      >
                        {dateTimeAgo}
                      </span>
                      <p
                        className=""
                        style={{ marginLeft: "46px", marginTop: "35px" }}
                        onClick={(e) => {
                          // e.stopPropagation();
                          setIndex(i);
                          hanldeOptions();
                        }}
                      >
                        {" "}
                        <img
                          src="./images/verticalDots.png"
                          alt=""
                          style={{ height: "15px" }}
                        />{" "}
                      </p>
                      {showPopup
                        ? index == i && (
                          <>
                            <div
                              style={{
                                display: "inline-block",
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                                top: "20px",
                              }}
                            >
                              {!item?.is_read && (
                                <>
                                  <div
                                    className="bg-primary"
                                    style={{
                                  
                                    }}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      handleRead(item?.id);
                                    }}
                                  >
                                    {lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Read"]:""}
                                  </div>
                                </>
                              )}
                              <div
                                className="bg-secondary"
                                style={{
                                  color: "black",
                                  border: "1px solid black",
                                  textAlign: "center",
                                  borderRadius: "2px",
                                }}
                                onClick={(e) => {
                                  // e.stopPropagation();
                                  handleDelete(item?.id);
                                }}
                              >
                                {t("Delete")}
                              </div>
                            </div>
                          </>
                        )
                        : ""}
                    </div>
                  </div>
                  <hr className="line" />
                </>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                color: "grey",
                marginTop: "50px",
              }}
            >
              {lang && Object.keys(lang).length > 0 ? lang[ln]?.Home["No New Notification Found"]:""}
            </div>
          )}
             <div style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        marginBottom: 10
      }}>
        <div>
          <p style={{ marginBottom: 0, paddingRight: 5, cursor: "pointer",color:"#000" }} onClick={() => {
            if (pageNo > 1) {

              setPageno(pageNo - 1)
              console.log("yo");
              newNoti.current = []
              setTimeout(()=>{
                getNotification()
              },1000)
             
            } else {
              console.log("no more data found");
            }
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["previous"]:""}</p> 
        </div>
        <input placeholder='Pg. no.' type="text"
          disabled={true}
          style={{
            textAlign: "center",
            width: 60,
            padding: 10,
            borderColor: "#f2edf3",
            backgroundColor: "#f2edf3",
            borderRadius: 10,
            borderWidth: 0
          }} value={pageNo + "/" + totalPage.current} />
        <div>
          <p style={{ marginBottom: 0, paddingLeft: 5, cursor: "pointer",color:"#000" }} onClick={() => {
            if (pageNo < totalPage.current) {
              setPageno(pageNo + 1)
              console.log("yono");
              newNoti.current = []
              setTimeout(()=>{
                getNotification()
              },1000)
            } else {
              console.log("no more data found");
            }
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Next"]:""}</p>
        </div>
      </div>
{blackPopup &&
                    <div className='blur-screen-full-area flex-center ' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', overflow: 'auto', background: 'rgb(0, 0, 0, 0.7' }}>
                      <BlackScreen item={seekerData.current} setBlackPopupValue={setBlackPopup} style={{ position: 'fixed' }} />
                    </div>
                  }


          {/* <div className="row msg-notification">
          <div className="col-2 px-0">
            <img src="./images/msg-noti.png" className="mr-0" alt="" />
          </div>
          <div className="col-8 pr-0 pb-2">
            <p className="text">
              HemaChandra, and 7 more candidates are found relevant ...
            </p>

            <button className="view-notification">View Message</button>
          </div>
          <div
            className="col-2 px-0"
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "end",
            }}
          >
            <p className="text notification-time-status">Today</p>
            <p className="">
              {" "}
              <img src="./images/verticalDots.png" alt="" />{" "}
            </p>
          </div>
        </div> */}
          {/* <hr className="line" /> */}
          {/* <div className="row candidates-notification">
          <div className="col-2 px-0 relative">
            <img src="./images/msg1.png" className="msg-profile mr-0 " alt="" />
            <img
              src="./images/msg1.png"
              className="msg-profile mr-0 second-notification-profile"
              alt=""
            />
            <img
              src="./images/msg1.png"
              className="msg-profile mr-0 third-notification-profile"
              alt=""
            />
          </div>
          <div className="col-8 pr-0 pb-2">
            <p className="text">
              HemaChandra, and 7 more candidates are found relevant ...
            </p>
            <button className="view-notification">View Candidates</button>
          </div>
          <div
            className="col-2 px-0"
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "end",
            }}
          >
            <p className="text notification-time-status">Today</p>
            <p className="">
              {" "}
              <img src="./images/verticalDots.png" alt="" />{" "}
            </p>
          </div>
        </div> */}
          {/* <hr className="line" /> */}
          {/* <div className="row msg-notification">
          <div className="col-2 px-0">
            <img src="./images/msg-noti.png" className="mr-0" alt="" />
          </div>
          <div className="col-8 pr-0 pb-2">
            <p className="text">
              HemaChandra, and 7 more candidates are found relevant ...
            </p>

            <button className="view-notification">View Message</button>
          </div>
          <div
            className="col-2 px-0"
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "end",
            }}
          >
            <p className="text notification-time-status">Today</p>
            <p className="">
              {" "}
              <img src="./images/verticalDots.png" alt="" />{" "}
            </p>
          </div>
        </div> */}
          {/* <hr className="line" /> */}
          {/* <div className="row candidates-notification">
          <div className="col-2 px-0 relative">
            <img src="./images/msg1.png" className="msg-profile mr-0 " alt="" />
            <img
              src="./images/msg1.png"
              className="msg-profile mr-0 second-notification-profile"
              alt=""
            />
            <img
              src="./images/msg1.png"
              className="msg-profile mr-0 third-notification-profile"
              alt=""
            />
          </div>
          <div className="col-8 pr-0 pb-2">
            <p className="text">
              HemaChandra, and 7 more candidates are found relevant ...
            </p>
            <button className="view-notification">View Candidates</button>
          </div>
          <div
            className="col-2 px-0"
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "end",
            }}
          >
            <p className="text notification-time-status">Today</p>
            <p className="">
              {" "}
              <img src="./images/verticalDots.png" alt="" />{" "}
            </p>
          </div>
        </div> */}
          {/* <hr className="line" /> */}
          {/* <div className="row msg-notification">
          <div className="col-2 px-0">
            <img src="./images/msg-noti.png" className="mr-0" alt="" />
          </div>
          <div className="col-8 pr-0 pb-2">
            <p className="text">
              HemaChandra, and 7 more candidates are found relevant ...
            </p>

            <button className="view-notification">View Message</button>
          </div>
          <div
            className="col-2 px-0"
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "end",
            }}
          >
            <p className="text notification-time-status">Today</p>
            <p className="">
              {" "}
              <img src="./images/verticalDots.png" alt="" />{" "}
            </p>
          </div>
        </div> */}
          {/* <hr className="line" /> */}
          {/* <div className="link">View All</div> */}
        </div>
      </div>
    </>
  );
};

export default Notification;
